(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputList', cpInputList);

    cpInputList.$inject = [];

    function cpInputList() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-list/input-list.html',
            scope: {
                type: '@',
                title: '@',
                object: '=',
                prop: '@'
            },
            link: function(scope, element, attrs, controller) {
                scope.onKeypress = onKeypress;
                scope.addItem = addItem;
                scope.removeItem = removeItem;

                activate();

                function activate() {
                    if (!angular.isArray(scope.object[scope.prop])) {
                        scope.object[scope.prop] = [];
                    }
                }

                function addItem(item) {
                    scope.object[scope.prop].unshift(item);
                }

                function removeItem(index) {
                    scope.object[scope.prop].splice(index, 1);
                }

                function isItemExist(item) {
                    return scope.object[scope.prop].indexOf(item) !== -1;
                }

                function onKeypress(event) {
                    if (event.which === 13) {
                        event.preventDefault();

                        if (!event.target.value) {
                            return;
                        }

                        if (isItemExist(event.target.value)) {
                            event.target.value = '';
                            return;
                        }

                        scope.addItem(event.target.value);
                        event.target.value = '';
                    }
                }
            }
        };
    }
})();
